var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnknown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.457 3.1992h-70.914c-13.953 0-25.344 11.391-25.344 25.344v70.785c0 13.953 11.391 25.344 25.344 25.344h70.785c13.953 0 25.344-11.391 25.344-25.344v-70.785c0.12891-13.949-11.266-25.344-25.215-25.344zm12.801 96.258c0 7.0391-5.7617 12.801-12.801 12.801h-70.914c-7.0391 0-12.801-5.7617-12.801-12.801v-70.914c0-7.0391 5.7617-12.801 12.801-12.801h70.785c7.0391 0 12.801 5.7617 12.801 12.801v70.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.258 28.93c-14.078 0-21.504 9.7266-23.039 19.84-0.25781 2.0469 1.4062 3.9688 3.457 3.9688h5.375c1.6641 0 3.0703-1.1523 3.3281-2.9453 0.64062-3.8398 3.0703-8.7031 10.879-8.7031 6.0156 0 8.4492 3.1992 9.3438 4.9922 1.4062 2.8164 1.1523 6.0156-0.51172 8.3203-1.6641 2.3047-3.3281 3.457-5.2461 4.7344-4.4805 3.1992-8.1914 6.5273-8.832 15.742-0.12891 2.0469 1.4062 3.7109 3.457 3.7109h5.2461c1.793 0 3.3281-1.4062 3.457-3.1992 0.25781-3.9688 1.2812-4.7344 3.7109-6.3984 2.1758-1.5352 5.1211-3.5859 8.0625-7.5508 4.4805-6.1445 4.9922-14.207 1.5352-21.121-3.7109-7.0391-11.266-11.391-20.223-11.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.023 84.863c-4.0977 0-7.4258 3.3281-7.4258 7.4258 0 4.0977 3.3281 7.4258 7.4258 7.4258 4.0977 0 7.4258-3.3281 7.4258-7.4258 0-4.0977-3.3281-7.4258-7.4258-7.4258z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnknown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unknown.53e4db8ca0aeb7932a2194ef18c6a502.svg";